module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "timeline"
  }, [_c('div', {
    staticClass: "timeline-cover sp-page-banner"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-contents"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h4', [_vm._v("Group Chat")]), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('viewChatLog')
      }
    }
  }, [_vm._v("View Chat")]), _vm._v(" "), (_vm.menu_tab_view.viewChatLog) ? _c('div', [((Object.keys(_vm.user).length > 0)) ? _c('div', [_c('component-chatroom', {
    attrs: {
      "chatter": {
        chatter_chat_from: _vm.user.user_id,
        chatter_chat_from_module: 1,
        chatter_set_active_chat: '',
        chatter_chat_to: 0,
        chatter_chat_to_module: 0,
        chatter_chat_group: 0,
        chatter_style: 2,
        chat_components_products: []
      }
    }
  })], 1) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-flat"
  }, [_c('div', [_c('h3', [_vm._v("Chats")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ec3530f"}!./src/pages/Chats/template.html
// module id = 442
// module chunks = 0